var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.785,
    height: 21.2,
    viewBox: "0 0 26.785 21.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-mail",
    "data-name": "Icon feather-mail",
    transform: "translate(-1.607 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_35",
    "data-name": "Trazado 35",
    d: "M5.4,6H24.6A2.407,2.407,0,0,1,27,8.4V22.8a2.407,2.407,0,0,1-2.4,2.4H5.4A2.407,2.407,0,0,1,3,22.8V8.4A2.407,2.407,0,0,1,5.4,6Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#a24b5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36",
    "data-name": "Trazado 36",
    d: "M27,9,15,17.4,3,9",
    transform: "translate(0 -0.6)",
    fill: "none",
    stroke: "#a24b5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.9459db7a87a42d34e49a33bce45a49ca.svg";
export { ForwardRef as ReactComponent };